import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardExpandToggler,
} from "../../../components/card/card.jsx";

import TopCards from "../components/top-cards";
import LocationCards from "../components/location-cards";
import { dashboard, machineProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import {
  generateLocationToArray,
  machineHealthColor,
} from "../../../utils/helper";
import { useNavigate } from "react-router-dom";
import AlarmBreakdown from "../components/alarm-breakdown-chart.jsx";
import AlarmTable from "../components/alarm-table.jsx";
import { LocationFilter } from "../../../components/LocationFilter";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext";

function EngineerOverview() {
  const {
    selectedLocationOverview,
    selectedMachineOverview,
    dateRangeOverview,
    updateSelectedLocationOverview,
    updateSelectedMachineOverview,
    updateDateRangeOverview,
  } = useDashboardContext();
  const navigate = useNavigate();
  const { config } = useAuth();
  const [lowestMachine, setLowestMachine] = useState([]);
  const [highestMachine, setHighestMachine] = useState([]);
  const [allLowestMachine, setAllLowestMachine] = useState([]);
  const [allMachines, setAllMachines] = useState([]);
  const [filteredMachines, setFilteredMachines] = useState([]);
  const [selectedHealth, setSelectedHealth] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [tmpStatusSelection, setTmpSelectedStatus] = useState("");
  const [tmpSelection, setTempSelection] = useState("");
  const [clickCounter, setClickCounter] = useState(0);
  const [clickStatusCounter, setClickStatusCounter] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedtedLocation, setSelectedtedLocation] = useState("");
  function randomNo() {
    return Math.floor(Math.random() * 60) + 30;
  }
  const [dateRangeCurrentWeek, setDateRangeCurrentWeek] = useState(
    "- Select Date Range -"
  );

  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    setStartDate(startDate);
    setEndDate(endDate);
    updateDateRangeOverview({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    });
    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");

    setDateRangeCurrentWeek(currentWeek);
  }

  async function fetchData() {
    const result = await dashboard.topMachine({});
    const data = await parserAPI(result);
    // set first 10 machines
    setLowestMachine(data.highest.slice(0, 10));
    setHighestMachine(data.lowest.slice(0, 10));
    setAllLowestMachine(data.highest);
  }

  async function getMachine() {
    try {
      const res = await machineProfile.list({ company: true });
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setAllMachines(data);
          setFilteredMachines(data);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    fetchData();
    getMachine();
  }, []);

  useEffect(() => {
    setTempSelection(selectedHealth);
    console.log({ tmpSelection, selectedHealth });
    if (tmpSelection !== selectedHealth) {
      setLowestMachine(
        allLowestMachine.filter(
          (machine) => machine.MachineHealth[0]?.status === selectedHealth
        )
      );
    } else {
      setTempSelection("");
      setLowestMachine(allLowestMachine);
    }
  }, [selectedHealth, clickCounter]);

  useEffect(() => {
    setTmpSelectedStatus(selectedStatus);
    if (tmpStatusSelection !== selectedStatus) {
    } else {
      setTmpSelectedStatus("");
      setSelectedStatus("");
      setLowestMachine(allLowestMachine);
    }
  }, [selectedStatus, clickStatusCounter]);

  const navigatePage = (url) => {
    navigate(url);
  };

  function containsAlerts(machineObject) {
    // Check if the machine has elements
    if (
      machineObject.machine_elements &&
      Array.isArray(machineObject.machine_elements)
    ) {
      // Iterate through each machine element
      for (let element of machineObject.machine_elements) {
        // Check if the machine element has deployments
        if (element.deployments && Array.isArray(element.deployments)) {
          // Iterate through each deployment
          for (let deployment of element.deployments) {
            // Check if the deployment contains alerts
            if (
              deployment.Alerts &&
              Array.isArray(deployment.Alerts) &&
              deployment.Alerts.length > 0
            ) {
              return deployment.Alerts[0].id;
            }
          }
        }
      }
    }
    return false; // No alerts found
  }
  const handleChangeLocationFilter = (location_id) => {
    updateSelectedLocationOverview(location_id);
  };

  const clickHealthHandler = async (status) => {
    // random number generator
    const randomNumber = randomNo();
    setClickCounter(randomNumber);
    //toggle if the status selectedHealth is the same change it to empty string
    if (selectedHealth === status) {
      setSelectedHealth("");
    } else {
      setSelectedHealth(status);
    }
  };
  const clickStatusHandler = async (status) => {
    // random number generator
    const randomNumber = randomNo();
    setClickStatusCounter(randomNumber);
    //toggle if the status selectedHealth is the same change it to empty string
    if (selectedStatus === status) {
      setSelectedStatus("");
    } else {
      setSelectedStatus(status);
    }
  };

  const machineUpdate = (e) => {
    updateSelectedMachineOverview(e.target.value);
  };

  return (
    <div>
      <div className="row mb-2 justify-content-end">
        <div className="col-3">
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onApply={handleDateApplyEvent}
          >
            <button
              className="btn btn-outline-theme text-truncate me-3 mb-2 mb-sm-0"
              style={{ width: "100%" }}
            >
              <i className="fa fa-fw fa-calendar me-1"></i>
              <span>{dateRangeCurrentWeek}</span>
              <i className="fa fa-fw fa-caret-down me-n1"></i>
            </button>
          </DateRangePicker>
        </div>

        <div className="col-4">
          <LocationFilter onChange={handleChangeLocationFilter} />
        </div>
        <div className="col-3">
          <select
            className="btn btn-outline-theme w-100"
            onChange={machineUpdate}
            value={selectedMachineOverview}
          >
            <option value="">- All Machines -</option>
            {filteredMachines.map((machine, index) => (
              <option key={index} value={machine.id}>
                {machine.machine_name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/*<Tour steps={steps} isOpen={isOpen} onRequestClose={closeTour} />*/}
      <TopCards
        onClick={clickHealthHandler}
        onStatusClick={clickStatusHandler}
      />
      <div className="row">
     
        {config?.is_matar ? (
          <div className="col-xl-6">
            <Card className="mb-3">
              <CardBody>
                <div className="d-flex fw-bold small mb-3">
                  <span className="flex-grow-1">
                    Top 5 Forcasted Asset Replacement
                  </span>
                  <CardExpandToggler />
                </div>
                <div className="table-responsive">
                  <table className="table table-striped table-borderless mb-2px small text-nowrap tr-hover">
                    <thead>
                      <tr>
                        <th>Asset</th>
                        <th>Zone</th>
                        <th>Replacement Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Air Compressor (ASD-GSE-01CR01-PAC002)</td>
                        <td>1</td>
                        <td>2028</td>
                      </tr>
                      <tr>
                        <td>Air Compressor (ASD-GSE-03CR02-PAC003)</td>
                        <td>1</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>Air Compressor (LSD-MWB-01WK13-PAC004)</td>
                        <td>1</td>
                        <td>2029</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </div>
        ) : null}
    

        <div className="col-xl-6">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1">Top Worst Machine</span>
                <CardExpandToggler />
              </div>
              <div className="table-responsive">
                <table className="table table-striped table-borderless mb-2px small text-nowrap tr-hover">
                  <tbody>
                    {lowestMachine.map((machine, index) => (
                      <tr key={index}>
                        <td>
                          <span className="d-flex align-items-center">
                            <i
                              className={
                                "bi bi-circle-fill fs-6px me-2 text-theme"
                              }
                            ></i>
                            {machine.machine_name}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              "badge d-block rounded-0 pt-5px w-70px  text-theme-900"
                            }
                            style={{
                              minHeight: "18px",
                              backgroundColor: machineHealthColor(
                                machine.MachineHealth[0]?.status
                              ),
                            }}
                          >
                            {machine.MachineHealth[0]?.status}
                          </span>
                        </td>
                        <td>
                          <a
                            className="text-decoration-none text-inverse btn btn-outline-theme btn-sm"
                            style={{
                              fontSize: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigatePage("/machine/" + machine.id)
                            }
                          >
                            <i className="bi bi-search"></i> Detail
                          </a>
                          {containsAlerts(machine) && (
                            <a
                              className="text-decoration-none text-inverse btn btn-danger btn-sm"
                              style={{
                                marginLeft: "5px",
                                fontSize: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigatePage(
                                  "/alarm/detail/" + containsAlerts(machine)
                                )
                              }
                            >
                              <i className="bi bi-search"></i> Alarm
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-xl-6">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1">Top Healthiest Machine</span>
                <CardExpandToggler />
              </div>
              <div className="table-responsive">
                <table className="table table-striped table-borderless mb-2px small text-nowrap tr-hover">
                  <tbody>
                    {highestMachine.map((machine, index) => (
                      <tr
                        key={index}
                        onClick={() => navigatePage("/machine/" + machine.id)}
                      >
                        <td>
                          <span className="d-flex align-items-center">
                            <i
                              className={
                                "bi bi-circle-fill fs-6px me-2 text-theme"
                              }
                            ></i>
                            {machine.machine_name}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              "badge d-block rounded-0 pt-5px w-70px  text-theme-900"
                            }
                            style={{
                              minHeight: "18px",
                              backgroundColor: machineHealthColor(
                                machine.MachineHealth[0]?.status
                              ),
                            }}
                          >
                            {machine.MachineHealth[0]?.status}
                          </span>
                        </td>
                        <td>
                          <a
                            onClick={() =>
                              navigatePage("/machine/" + machine.id)
                            }
                            className="text-decoration-none text-inverse"
                          >
                            <i className="bi bi-search"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default EngineerOverview;
